import * as React from "react";
const SvgEdit01 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M9 15h6.75m-13.5 0h1.256c.367 0 .55 0 .723-.041.153-.037.3-.098.433-.18.152-.093.282-.223.541-.482l9.422-9.422a1.591 1.591 0 0 0-2.25-2.25l-9.422 9.422c-.26.26-.39.39-.482.54a1.5 1.5 0 0 0-.18.434c-.041.173-.041.356-.041.723z"
    />
  </svg>
);
export default SvgEdit01;
